"use strict";

exports.__esModule = true;
exports.TransformMode = exports.BoneData = void 0;
var _Utils = require("./Utils");
/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated January 1, 2020. Replaces all prior versions.
 *
 * Copyright (c) 2013-2020, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software
 * or otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
 * THE SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/
/** Stores the setup pose for a {@link Bone}. */
var BoneData = function BoneData(index, name, parent) {
  /** The index of the bone in {@link Skeleton#getBones()}. */
  this.index = 0;
  /** The name of the bone, which is unique across all bones in the skeleton. */
  this.name = null;
  /** @returns May be null. */
  this.parent = null;
  /** The bone's length. */
  this.length = 0;
  /** The local x translation. */
  this.x = 0;
  /** The local y translation. */
  this.y = 0;
  /** The local rotation. */
  this.rotation = 0;
  /** The local scaleX. */
  this.scaleX = 1;
  /** The local scaleY. */
  this.scaleY = 1;
  /** The local shearX. */
  this.shearX = 0;
  /** The local shearX. */
  this.shearY = 0;
  /** The transform mode for how parent world transforms affect this bone. */
  this.transformMode = TransformMode.Normal;
  /** When true, {@link Skeleton#updateWorldTransform()} only updates this bone if the {@link Skeleton#skin} contains this
    * bone.
    * @see Skin#bones */
  this.skinRequired = false;
  /** The color of the bone as it was in Spine. Available only when nonessential data was exported. Bones are not usually
   * rendered at runtime. */
  this.color = new _Utils.Color();
  if (index < 0) throw new Error("index must be >= 0.");
  if (!name) throw new Error("name cannot be null.");
  this.index = index;
  this.name = name;
  this.parent = parent;
};
/** Determines how a bone inherits world transforms from parent bones. */
exports.BoneData = BoneData;
var TransformMode;
exports.TransformMode = TransformMode;
(function (TransformMode) {
  TransformMode[TransformMode["Normal"] = 0] = "Normal";
  TransformMode[TransformMode["OnlyTranslation"] = 1] = "OnlyTranslation";
  TransformMode[TransformMode["NoRotationOrReflection"] = 2] = "NoRotationOrReflection";
  TransformMode[TransformMode["NoScale"] = 3] = "NoScale";
  TransformMode[TransformMode["NoScaleOrReflection"] = 4] = "NoScaleOrReflection";
})(TransformMode || (exports.TransformMode = TransformMode = {}));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJfVXRpbHMiLCJyZXF1aXJlIiwiQm9uZURhdGEiLCJpbmRleCIsIm5hbWUiLCJwYXJlbnQiLCJsZW5ndGgiLCJ4IiwieSIsInJvdGF0aW9uIiwic2NhbGVYIiwic2NhbGVZIiwic2hlYXJYIiwic2hlYXJZIiwidHJhbnNmb3JtTW9kZSIsIlRyYW5zZm9ybU1vZGUiLCJOb3JtYWwiLCJza2luUmVxdWlyZWQiLCJjb2xvciIsIkNvbG9yIiwiRXJyb3IiLCJleHBvcnRzIl0sInNvdXJjZXMiOlsiLi4vc3JjL0JvbmVEYXRhLnRzIl0sInNvdXJjZXNDb250ZW50IjpbbnVsbF0sIm1hcHBpbmdzIjoiOzs7O0FBNkJBLElBQUFBLE1BQUEsR0FBQUMsT0FBQTtBQTdCQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQStCQTtBQUFBLElBQ2FDLFFBQVEsR0E4Q3BCLFNBQUFBLFNBQWFDLEtBQWEsRUFBRUMsSUFBWSxFQUFFQyxNQUFnQjtFQTdDMUQ7RUFDQSxLQUFBRixLQUFLLEdBQVcsQ0FBQztFQUVqQjtFQUNBLEtBQUFDLElBQUksR0FBVyxJQUFJO0VBRW5CO0VBQ0EsS0FBQUMsTUFBTSxHQUFhLElBQUk7RUFFdkI7RUFDQSxLQUFBQyxNQUFNLEdBQVcsQ0FBQztFQUVsQjtFQUNBLEtBQUFDLENBQUMsR0FBRyxDQUFDO0VBRUw7RUFDQSxLQUFBQyxDQUFDLEdBQUcsQ0FBQztFQUVMO0VBQ0EsS0FBQUMsUUFBUSxHQUFHLENBQUM7RUFFWjtFQUNBLEtBQUFDLE1BQU0sR0FBRyxDQUFDO0VBRVY7RUFDQSxLQUFBQyxNQUFNLEdBQUcsQ0FBQztFQUVWO0VBQ0EsS0FBQUMsTUFBTSxHQUFHLENBQUM7RUFFVjtFQUNBLEtBQUFDLE1BQU0sR0FBRyxDQUFDO0VBRVY7RUFDQSxLQUFBQyxhQUFhLEdBQUdDLGFBQWEsQ0FBQ0MsTUFBTTtFQUVwQzs7O0VBR0EsS0FBQUMsWUFBWSxHQUFHLEtBQUs7RUFFcEI7O0VBRUEsS0FBQUMsS0FBSyxHQUFHLElBQUlDLFlBQUssRUFBRTtFQUdsQixJQUFJaEIsS0FBSyxHQUFHLENBQUMsRUFBRSxNQUFNLElBQUlpQixLQUFLLENBQUMscUJBQXFCLENBQUM7RUFDckQsSUFBSSxDQUFDaEIsSUFBSSxFQUFFLE1BQU0sSUFBSWdCLEtBQUssQ0FBQyxzQkFBc0IsQ0FBQztFQUNsRCxJQUFJLENBQUNqQixLQUFLLEdBQUdBLEtBQUs7RUFDbEIsSUFBSSxDQUFDQyxJQUFJLEdBQUdBLElBQUk7RUFDaEIsSUFBSSxDQUFDQyxNQUFNLEdBQUdBLE1BQU07QUFDckIsQ0FBQztBQUdGO0FBQUFnQixPQUFBLENBQUFuQixRQUFBLEdBQUFBLFFBQUE7QUFDQSxJQUFZYSxhQUErRjtBQUFBTSxPQUFBLENBQUFOLGFBQUEsR0FBQUEsYUFBQTtBQUEzRyxXQUFZQSxhQUFhO0VBQUdBLGFBQUEsQ0FBQUEsYUFBQSwwQkFBTTtFQUFFQSxhQUFBLENBQUFBLGFBQUEsNENBQWU7RUFBRUEsYUFBQSxDQUFBQSxhQUFBLDBEQUFzQjtFQUFFQSxhQUFBLENBQUFBLGFBQUEsNEJBQU87RUFBRUEsYUFBQSxDQUFBQSxhQUFBLG9EQUFtQjtBQUFDLENBQUMsRUFBL0ZBLGFBQWEsS0FBQU0sT0FBQSxDQUFBTixhQUFBLEdBQWJBLGFBQWEifQ==